import ButtonYellow from '../ButtonYellow/ButtonYellow';

const BtnStudyPlan = ({ title, scrollToCourseCard = () => {} }) => {
  return (
    title?.value && (
      <div className="btn-more-detail mt-3 mb-1 d-flex align-self-center align-self-lg-start">
        <ButtonYellow
          className="button-yellow"
          ifispress={() => scrollToCourseCard()}
          title={
            <div className="btn-content d-flex align-items-center">
              <span>{title.value}</span>
              {/* <div className="icon-container ps-3">
                        <FontAwesomeIcon icon={faDownload} />
                      </div> */}
            </div>
          }
        />
      </div>
    )
  );
};

export default BtnStudyPlan;
